import { useTranslation } from 'react-i18next'

export function getDuration (timestamp: number): string {
  const actualTimeStamp = new Date().getTime()
  const differenceInSeconds = (actualTimeStamp - timestamp) / 1000
  const { t } = useTranslation()
  let output = `${differenceInSeconds} s`

  // Jahre
  if (differenceInSeconds >= 31536000) {
    const yearCount = Math.floor(differenceInSeconds / 86400)
    output = `${t('postCommon:for')} ${yearCount === 1 ? yearCount + ' ' + t('postCommon:year') : yearCount + ' ' + t('postCommon:years')}}`
  }

  // Monate
  if (differenceInSeconds >= 2419001) {
    output = `${t('postCommon:for')} ${Math.floor(differenceInSeconds / 2628000)} ${t('postCommon:month')}`
  }

  // Wochen
  if (differenceInSeconds < 2419000) {
    output = `${t('postCommon:for')} ${Math.floor(differenceInSeconds / 604800)} ${t('postCommon:week')}`
  }

  // Tage
  if (differenceInSeconds < 518500) {
    const daysCount = Math.floor(differenceInSeconds / 86400)
    output = `${t('postCommon:for')} ${daysCount === 1 ? daysCount + ' ' + t('postCommon:day') : daysCount + ' ' + t('postCommon:days')}`
  }

  // Stunden
  if (differenceInSeconds < 86400) {
    output = `${t('postCommon:for')} ${Math.floor(differenceInSeconds / 3600)} ${t('postCommon:hour')}`
  }

  // Minuten
  if (differenceInSeconds < 3600) {
    output = `${t('postCommon:for')} ${Math.floor(differenceInSeconds / 60)} ${t('postCommon:minute')}`
  }

  return output
}
